export const numeroAString = (num: number | string = '') =>
  String(num).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const shortNumber = (num = 0) => {
  let final = String(num);

  if (num >= 1_000_000) {
    final = `${Math.round((num * 10) / 1e6) / 10}M`;
  } else if (num >= 1_000) {
    final = `${Math.round((num * 10) / 1e3) / 10}K`;
  }
  return final;
};

export const isNumericValue = (value: string | number) =>
  !Number.isNaN(Number.parseInt(String(value)));

export const formatNotifDate = (date: Date | string) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('es-CL', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};
